define('toolkit/b-dropdown/b-dropdown', [
	'jquery',
	'toolkit/b-toolkit/b-toolkit',
	'toolkit/b-toolkit/b-toolkit.cache',

	'toolkit/b-list/b-list',
	'toolkit/b-controls-group-utils/b-controls-group-utils'
], function ($, toolkit, cache) {
	'use strict';

	var CURRENT_ITEM_CLASS = 'b-dropdown__list__item_current';
	var MODS_MULTISELECT = 'multiselect';

	var BDropdown = toolkit.create('b-dropdown', 'b-list', {
		minListHeight: 80,
		minBottomMargin: 15,
		animation: false,
		unselectable: false,
		scroll: null, // Scroll element
		//открыта ли выпадалка
		_expanded: false,

		resizeDebounce: 200,

		init: function () {
			this._hide = this._hide.bind(this);
			this._bindOutside = this._bindOutside.bind(this);

			this.$ctrl = (this.$ctrl || this.$('__ctrl'))
				.on('tap.' + this.uniqid, this._onCtrlClick.bind(this));
			this.$list = (this.$list || this.$('__list'))
				.on('tap.' + this.uniqid, '[data-name]', this._onItemClick.bind(this));

			toolkit['b-list'].fn.init.call(this);

			this._setScrollDebounce = toolkit.debounce(
				this._setScroll.bind(this, true),
				this.resizeDebounce,
				this
			);
		},

		/**
		 *
		 * @param {HTMLElement} parent
		 * @param {HTMLElement} child
		 * @private
		 */
		_scrollIntoView: function (parent, child) {
			try {
				var parentRect = parent.getBoundingClientRect();
				var childRect = child.getBoundingClientRect();

				var topDelta = parentRect.top - childRect.top;
				var bottomDelta = (childRect.top + childRect.height) -
					(parentRect.top + parentRect.height);

				if (topDelta > 0) {
					parent.scrollTop = parent.scrollTop - topDelta;
				} else if (bottomDelta > 0) {
					parent.scrollTop = parent.scrollTop + bottomDelta;
				}

			} catch (error) {
				console.warn('Не удалось проскролить до элемента в компоненте b-dropdown');
			}
		},

		/**
		 * Устанавливаем выделение по селектору для одного элемента
		 * и скролим чтобы он был виден
		 *
		 * @param {string} selector
		 */
		setSelectedAndScroll: function (selector) {
			this._unselectAll();

			var $currentItem = this.$list.find(selector);

			if ($currentItem.length) {
				$currentItem.toggleMod('selected');

				// нужно теперь переместить скролл так чтобы этот элемент был виден

				this._scrollIntoView(this.$list[0], $currentItem[0]);
			}
		},

		setCurrentItem: function (item) {
			var selector = '';

			if (this.hasMod(MODS_MULTISELECT)) {
				if (item.num !== void 0) {
					selector = '[data-num="' + item.num + '"]';
					this.$('__list__item' + selector).toggleClass(CURRENT_ITEM_CLASS);
				}
			} else {
				this.setTitle(item.text);

				if (item.image) {
					this.setIcon(item.image);
				}

				if (item.color) {
					this.setColor(item.color);
				}

				if (item.num !== void 0) {
					selector = '[data-num="' + item.num + '"]';
					this.$('__list__item').removeClass(CURRENT_ITEM_CLASS)
						.filter(selector).addClass(CURRENT_ITEM_CLASS);

					// нужно пометить элемент как selected
					this.setSelectedAndScroll(selector);
				}
			}
		},

		/**
		 * Set active item
		 * @param id
		 * @returns {this}
		 */
		setActiveItem: function(id) {
			this.$('__list__item_active').toggleMod('active', false);
			this.$el.find('[data-id="'+id+'"]').toggleMod('active', true);
			this.data.activeId = id;

			return this;
		},

		setTitle: function (text) {
			this.$('__ctrl__text').text(text);
		},

		setIcon: function (url) {
			this.$('__ctrl__image').css({'background-image': 'url(' + url + ')'});
		},

		setColor: function (color) {
			this.$('__ctrl').css('color', color);
		},

		expand: function() {
			this._expand();
		},

		hide: function () {
			this.toggleMod('expanded', false);
			this._expanded = false;
			this._bindOutside();
			this._hideAll();

			if (this.hasMod('auto-size-list')) {
				$(window).off('resize', this._setScrollDebounce);
			}
		},

		/**
		 * Выбираем текущий активный элмент
		 *
		 * @returns {boolean} true если этот элемент нашелся и мы по нему кликнули
		 */
		selectCurrentItem: function() {
			var $items = this.$list.find('.b-dropdown__list__item_selected');
			if ($items.length) {
				$items.eq(0).trigger('tap');
				return true;
			} else {
				return false;
			}
		},

		_isAllowHide: function(item) {
			// Не закрывать меню
			// если ткнули в элемент с модификатором unselectable или
			// если ткнули в список и весь дродаун unselectable или
			// список мультиселект
			return !(
				this.unselectable ||
				toolkit.hasMod(item, 'unselectable') ||
				this.hasMod(MODS_MULTISELECT)
			);
		},

		_hideAll: function (evt) {
			this.$list.hide().css('zIndex', 0);
			this._unsetScroll();
			this.emit('collapse');
			setTimeout(this._toggleKeyboard.bind(this, false), 0);
			if (evt && evt.type === 'keydown') {
				this._bindOutside();
			}
		},

		_hide: function (evt) {
			var item = $(evt.target).closest(this.s('__list__item')),
				list = this.$list.has(evt.target);

			if (
				list.length && !this._isAllowHide(item)
			) {
				// сохраняем возможность закрыть меню по клику куда то вовне
				setTimeout(this._bindOutside, 0);
			} else {
				this.toggleMod('expanded', false);
				this._expanded = false;

				this._hideAll(evt);
			}

			if (this.hasMod('auto-size-list')) {
				$(window).off('resize', this._setScrollDebounce);
			}
		},

		_bindOutside: function (){
			$(document)[cache.has(this.uniqid) && this.isExpanded() ? 'one' : 'unbind'](
				'tap.' + this.uniqid + ' select.' + this.uniqid, this._hide
			);
		},

		_onCtrlClick: function (evt){
			var $target = $(evt.target),
				TOOLKIT_SIGN = '[data-name],[data-id]';

			if (
				// если клик произошёл не на самом контроле
				!$target.is(this.$ctrl) &&
				(this.$el.is('[aria-disabled]') ||
				// TODO: Это полный пипец. Нужно оставить только !evt.isDefaultPrevented(),
				// а во всех внутренних блоках превентить событие.

				// предотвращаем раскрытие, если клик в дочернем блоке
				($target.parent().is(this.$ctrl) && $target.is(TOOLKIT_SIGN)) ||
				// предотвращаем раскрытие, если клик в любом из дочерних блоков
				$target.parentsUntil(this.$ctrl, TOOLKIT_SIGN).length)
			) {
				return;
			}

			evt.preventDefault();
			this._expand();
		},


		_expand: function () {
			//Если уже открыт, то не выполняем лишний раз
			if(this.isExpanded()){
				return;
			}

			this.$list.show().css('zIndex', 1e6);
			this.toggleMod('expanded', true);
			this._expanded = true;

			this.emit('expand');
			this._setScroll();
			this._toggleKeyboard(true);

			setTimeout(this._bindOutside, 0);
			this._setMinWidth();
			this._setScrollPrevent();

			// добавляем авторезайзер, если есть модификатор
			if (this.hasMod('auto-size-list')) {
				$(window).on('resize', this._setScrollDebounce);
			}
		},

		/**
		 *
		 * Устанавливаем блокировку родительских скроллов
		 * @private
		 */
		_setScrollPrevent: function(){
			if(this._scrollPreventerReady){
				return;
			}

			this.$list.on('wheel mousewheel', this._eventMouseWheel);

			this._scrollPreventerReady = true;
		},

		/**
		 *
		 * Обработчик скролла, вешается на DOM элемент
		 * @private
		 */
		_eventMouseWheel: function(e) {
			//Делаем если только список скролируемый
			if(this.scrollHeight > this.offsetHeight){
				var toTop;

				if('deltaY' in e.originalEvent){
					toTop = e.originalEvent.deltaY < 0;
				} else {
					toTop = e.originalEvent.wheelDelta > 0;
				}

				if(
					//Скролли вниз
					(!toTop && this.scrollTop >= this.scrollHeight - this.offsetHeight) ||
					//Скролли вверх
					(toTop && !this.scrollTop)
				){
					e.preventDefault();
					e.stopPropagation();
				}
			}
		},

		/**
		 *
		 * Устанавливаем min-width в зависимости от ширины родителя,
		 * чтобы не было узких выпадалок
		 * MAIL-43108
		 */
		_setMinWidth: function() {
			this.$list.css('min-width', this.$el.width());

			/**
			 * Дальше идет фикс бага, воспроизводящегося в ИЕ11-
			 * MAIL-45589
			 * Короче в ИЕ, причем во всех добавляется ширина скролла к min-width
			 * После установки min-width, мы смотрим,
			 * если ширина списка больше контейнера,
			 * то именьшаем min-width на разницу в ширине.
			 * У блоков с широким контентов ничего не поменяется, т.к.
			 * ему min-width не важен, а у ИЕ(или еще у кого-нить) пофиксится
			 *
			 */
			var dropdownWidth = this.$el[0].offsetWidth;
			var dropdownListWidth = this.$list[0].offsetWidth;
			if(dropdownListWidth > dropdownWidth){
				this.$list.css(
					'min-width', dropdownWidth-(dropdownListWidth-dropdownWidth)
				);
			}
		},

		_getUIEvent: function () {
			return toolkit['b-controls-group-utils'].fn._getUIEvent.apply(this, arguments);
		},


		_onItemClick: function (evt) {
			toolkit['b-controls-group-utils'].fn._emitUIEvent.call(this, evt);

			//Если для экземпляра дропдауна добавили метод onClick,
			// то вызовется эта функция
			this.emit('click', evt);
		},


		isExpanded: function () {
			return this._expanded;
		},

		_setScroll: function(saveScroll){
			var $list = this.$list;

			var startScrollTop;
			if (saveScroll) {
				startScrollTop = $list.scrollTop();
			}

			$list.css({
				height: '',
				overflow: ''
			});

			var $win = $(window),
				$scroll = $(this.scroll || window),
				winHeight = $win.height(),
				listTop = $list.offset().top - $scroll.scrollTop(),
				listHeight = $list.outerHeight();

			var $current = this.$el.find('.b-dropdown__list__item_current'),
				data = $current.data() || {},
				height;

			if( (listHeight + listTop) > winHeight ){
				$list.css({
					height: Math.max(
						this.minListHeight, winHeight - listTop - this.minBottomMargin
					),
					overflow: 'auto'
				});
			}

			if (saveScroll) {
				$list.scrollTop(startScrollTop);
			} else {
				if (data.num) {
					height = $current.outerHeight();
					$list.scrollTop(data.num * height);
				}
			}
		},


		_unsetScroll: function(){
			this.$list.css({ overflow: '', height: '' });
		},

		destroy: function () {
			this._bindOutside();
			this.undelegateEvents(this.$ctrl);
			this.undelegateEvents(this.$list);

			toolkit['b-list'].fn.destroy.apply(this, arguments);
			this.$ctrl = null;
		}
	});

	BDropdown.CURRENT_ITEM_CLASS = CURRENT_ITEM_CLASS;

	return BDropdown;
});
